// ---------------------------------------------------------------------------
// Restaurant videos: reading the shelf, and the callables in
// functions/videos.js that add, report and refresh them.
// ---------------------------------------------------------------------------

import { collection, query, where, orderBy, limit, getDocs, getDoc, doc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions, BUSINESSES } from '../firebase';

export const PLATFORMS = {
  tiktok: { name: 'TikTok', color: '#010101' },
  instagram: { name: 'Instagram', color: '#C13584' },
  facebook: { name: 'Facebook', color: '#1877F2' },
  youtube: { name: 'YouTube', color: '#FF0000' },
};

export async function fetchVideos(businessId, max = 24) {
  const snap = await getDocs(query(
    collection(db, BUSINESSES, businessId, 'videos'),
    where('status', '==', 'visible'),
    orderBy('createdAt', 'desc'),
    limit(max),
  ));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function fetchVideo(businessId, id) {
  const snap = await getDoc(doc(db, BUSINESSES, businessId, 'videos', id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

function callable(name) {
  const fn = httpsCallable(functions, name);
  return (data) => fn(data).then((r) => r.data);
}

export const addVideo = callable('addVideo');
export const reportVideo = callable('reportVideo');
export const deleteVideo = callable('deleteVideo');
export const moderateVideo = callable('moderateVideo');
export const refreshVideoThumbnail = callable('refreshVideoThumbnail');

// A quick guess while typing, just to label the field ("TikTok link") — the
// server does the real parsing and checking.
export function guessPlatform(text) {
  const t = String(text || '').toLowerCase();
  if (/tiktok\.com/.test(t)) return 'tiktok';
  if (/instagram\.com/.test(t)) return 'instagram';
  if (/facebook\.com|fb\.watch/.test(t)) return 'facebook';
  if (/youtube\.com|youtu\.be/.test(t)) return 'youtube';
  return null;
}
